/* =====================================================================
   Completely Bare — CPB redesign behaviour (vanilla, deferred, ~10KB)
   header nav · carousels · AJAX add-to-cart + toast · PDP buy box
   (variants, subscribe/one-time, cadence, qty, gallery, sticky bar) ·
   UGC video · cross-sell recommendations
   ===================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.CPB || {};
  var ROUTES = CFG.routes || { cartAdd: '/cart/add', cart: '/cart' };

  /* ---------- money ---------- */
  function money(cents, fmt) {
    fmt = fmt || CFG.money || '${{amount}}';
    var n = (cents || 0) / 100;
    var fixed = n.toFixed(2).split('.');
    var thousands = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var out;
    if (/amount_no_decimals_with_comma_separator/.test(fmt)) out = fmt.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, thousands(String(Math.round(n)), '.'));
    else if (/amount_with_comma_separator/.test(fmt)) out = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, thousands(fixed[0], '.') + ',' + fixed[1]);
    else if (/amount_no_decimals/.test(fmt)) out = fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, thousands(String(Math.round(n)), ','));
    else out = fmt.replace(/\{\{\s*amount\s*\}\}/, thousands(fixed[0], ',') + '.' + fixed[1]);
    return out.replace(/<[^>]*>/g, '').replace(/\$\s+/g, '$');
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-cpb-toast]');
    if (!t) return;
    var tx = $('[data-cpb-toast-text]', t);
    if (tx) tx.textContent = msg || 'Added to cart';
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- cart ---------- */
  function cartAdd(items) {
    /* Ask Shopify to re-render the header section in the same request, so the cart
       count comes from the post-add cart state (no race with a follow-up /cart.js). */
    return fetch(ROUTES.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cpb-header' })
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function (added) {
      var count = null;
      try {
        var html = added.sections && added.sections['cpb-header'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-cpb-cart-count]');
          if (el) count = parseInt(el.textContent, 10);
        }
      } catch (e) { /* fall through */ }
      var finish = function (cart) {
        var n = (count != null && !isNaN(count)) ? count : (cart ? cart.item_count : null);
        if (n == null) { var cur = parseInt(($('[data-cpb-cart-count]') || {}).textContent || '0', 10) || 0; n = cur + (added.items || [added]).reduce(function (a, it) { return a + (it.quantity || 1); }, 0); }
        $$('[data-cpb-cart-count]').forEach(function (el) { el.textContent = n; });
        document.dispatchEvent(new CustomEvent('cpb:cart:added', { detail: { added: added, cart: cart, count: n } }));
        return cart || { item_count: n };
      };
      if (count != null) return finish(null);
      return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(finish);
    });
  }
  window.CPB = window.CPB || {};
  window.CPB.cartAdd = cartAdd;
  window.CPB.toast = toast;

  /* Quick-add buttons (cards, bundle promo) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cpb-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…';
    cartAdd([{ id: id, quantity: 1 }]).then(function () { toast('Added to cart'); })
      .catch(function (err) { toast(err.message || 'Could not add to cart'); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; });
  });

  /* ---------- header ---------- */
  (function header() {
    var burger = $('[data-cpb-nav-toggle]');
    var nav = $('[data-cpb-mobile-nav]');
    if (burger && nav) {
      var close = function () { nav.hidden = true; burger.setAttribute('aria-expanded', 'false'); };
      burger.addEventListener('click', function () {
        var open = nav.hidden;
        nav.hidden = !open;
        burger.setAttribute('aria-expanded', String(open));
      });
      nav.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
      window.addEventListener('resize', function () { if (window.innerWidth >= 860 && !nav.hidden) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
    }
    $$('[data-cpb-drop]').forEach(function (item) {
      var link = $('.cpb-nav-link', item);
      var set = function (v) { link && link.setAttribute('aria-expanded', String(v)); };
      item.addEventListener('mouseenter', function () { set(true); });
      item.addEventListener('mouseleave', function () { set(false); });
      item.addEventListener('focusin', function () { set(true); });
      item.addEventListener('focusout', function () { set(false); });
    });
  })();

  /* ---------- carousels (bestsellers) ---------- */
  $$('[data-cpb-carousel]').forEach(function (c) {
    var track = $('[data-cpb-track]', c);
    if (!track) return;
    var prev = $('[data-cpb-prev]', c), next = $('[data-cpb-next]', c), dots = $('[data-cpb-dots]', c);
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) { prev && (prev.hidden = true); next && (next.hidden = true); return; }
    if (dots) items.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b);
    });
    function index() {
      var best = 0, bd = Infinity;
      items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth, i = index();
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function go(i) {
      var it = items[Math.max(0, Math.min(items.length - 1, i))];
      if (it) track.scrollTo({ left: it.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    prev && prev.addEventListener('click', function () { go(index() - 1); });
    next && next.addEventListener('click', function () { go(index() + 1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- PDP ---------- */
  $$('[data-cpb-product]').forEach(function (root) {
    var dataEl = $('[data-cpb-variants]', root), form = $('[data-cpb-form]', root);
    if (!dataEl || !form) return;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var fmt = root.dataset.moneyFormat || CFG.money;
    var kitCompare = parseInt(root.dataset.compare || '0', 10) || 0;
    var idInput = $('[data-cpb-variant-id]', form);
    var planInput = $('[data-cpb-selling-plan]', form);
    var qtyInput = $('[data-cpb-qty-input]', form);
    var cadence = $('[data-cpb-cadence]', root);
    var planCards = $$('[data-cpb-plan]', root);
    var atc = $('[data-cpb-atc]', form), atcLabel = $('[data-cpb-atc-label]', form);
    var atcText = atcLabel ? atcLabel.textContent.split(' · ')[0] : 'Add to Cart';
    var stickyBar = $('[data-cpb-sticky]', root), stickyBtn = $('[data-cpb-sticky-atc]', root);
    var variant = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var plan = (planInput && !planInput.disabled) ? 'sub' : 'once';

    function planKeys(v) { return Object.keys(v.plans || {}); }
    function planId() {
      if (cadence && variant.plans && variant.plans[cadence.value] != null) return cadence.value;
      return planKeys(variant)[0] || '';
    }
    function subPrice() { var id = planId(); return (variant.plans && variant.plans[id] != null) ? variant.plans[id] : variant.price; }
    function unitPrice() { return plan === 'sub' && planKeys(variant).length ? subPrice() : variant.price; }
    function compareFor(unit) { var c = kitCompare > 0 ? kitCompare : (variant.compare_at_price || 0); return c > unit ? c : 0; }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function render() {
      var unit = unitPrice(), cmp = compareFor(unit);
      $$('[data-cpb-price]', root).forEach(function (el) { el.textContent = money(unit, fmt); });
      $$('[data-cpb-compare]', root).forEach(function (el) { el.hidden = !cmp; if (cmp) el.textContent = money(cmp, fmt); });
      var save = $('[data-cpb-save]', root);
      if (save) { save.hidden = !cmp; if (cmp) save.textContent = 'Save ' + money(cmp - unit, fmt) + ' · ' + Math.round((cmp - unit) / cmp * 100) + '% off'; }
      var sp = $('[data-cpb-sub-price]', root); if (sp) sp.textContent = money(subPrice(), fmt);
      var op = $('[data-cpb-once-price]', root); if (op) op.textContent = money(variant.price, fmt);
      if (atc) { atc.disabled = !variant.available; if (atcLabel) atcLabel.textContent = variant.available ? atcText + ' · ' + money(unit * qty(), fmt) : 'Sold out'; }
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (planInput) {
        var pid = plan === 'sub' ? planId() : '';
        planInput.disabled = !pid; planInput.value = pid;
      }
      planCards.forEach(function (c) { c.classList.toggle('is-selected', c.dataset.cpbPlan === plan); });
      renderPacks();
    }

    /* Multipack tiles: per-pack price for the current purchase type + "SAVE X%" vs. the 1-pack */
    function renderPacks() {
      $$('[data-cpb-packs]', form).forEach(function (fs) {
        var idx = parseInt(fs.dataset.optionIndex, 10), sel = selected();
        var oneUnit = null;
        $$('[data-cpb-pack]', fs).forEach(function (tile) {
          var input = $('input', tile); if (!input) return;
          var test = sel.slice(); test[idx] = input.value;
          var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); })[0];
          var units = parseInt(tile.dataset.units, 10) || 1;
          if (v && units === 1) oneUnit = v.price;
        });
        $$('[data-cpb-pack]', fs).forEach(function (tile) {
          var input = $('input', tile), priceEl = $('[data-cpb-pack-price]', tile), saveEl = $('[data-cpb-pack-save]', tile);
          var test = sel.slice(); test[idx] = input.value;
          var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); })[0];
          tile.classList.toggle('is-unavailable', !(v && v.available));
          if (!v) { if (priceEl) priceEl.textContent = ''; if (saveEl) saveEl.hidden = true; return; }
          var keys = Object.keys(v.plans || {});
          var unit = v.price;
          if (plan === 'sub' && keys.length) unit = (cadence && v.plans[cadence.value] != null) ? v.plans[cadence.value] : v.plans[keys[0]];
          if (priceEl) priceEl.textContent = money(unit, fmt);
          var units = parseInt(tile.dataset.units, 10) || 1;
          var cmp = v.compare_at_price > v.price ? v.compare_at_price : (units > 1 && oneUnit ? oneUnit * units : 0);
          if (saveEl) {
            if (cmp > v.price) { saveEl.hidden = false; saveEl.textContent = 'Save ' + Math.round((cmp - v.price) / cmp * 100) + '%'; }
            else saveEl.hidden = true;
          }
        });
      });
    }

    /* variant options */
    var opts = $$('[data-cpb-options] input[type="radio"]', form);
    function selected() { var arr = []; opts.forEach(function (i) { if (i.checked) arr[parseInt(i.dataset.optionIndex, 10)] = i.value; }); return arr; }
    function find(sel) { return variants.filter(function (v) { return v.options.every(function (o, k) { return sel[k] == null || o === sel[k]; }); })[0]; }
    function availability() {
      var sel = selected();
      opts.forEach(function (i) {
        var test = sel.slice(); test[parseInt(i.dataset.optionIndex, 10)] = i.value;
        var m = variants.filter(function (v) { return v.options.every(function (o, k) { return o === test[k]; }); })[0];
        var wrap = i.closest('.cpb-option__value'); if (wrap) wrap.classList.toggle('is-unavailable', !(m && m.available));
      });
    }
    opts.forEach(function (i) {
      i.addEventListener('change', function () {
        var sel = selected();
        var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
        if (!v) {
          /* No variant has this exact combination: keep the option the shopper just chose
             and snap the other options to the first variant that carries it. */
          var idx = parseInt(i.dataset.optionIndex, 10);
          v = variants.filter(function (x) { return x.options[idx] === i.value && x.available; })[0]
            || variants.filter(function (x) { return x.options[idx] === i.value; })[0];
          if (v) opts.forEach(function (o) { o.checked = v.options[parseInt(o.dataset.optionIndex, 10)] === o.value; });
        }
        if (v) {
          variant = v; idInput.value = v.id;
          if (v.media) gallery.showById(v.media);
          try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) { /* noop */ }
        }
        availability(); render();
      });
    });

    /* purchase options */
    planCards.forEach(function (card) {
      var radio = $('input[type="radio"]', card);
      var set = function () { plan = card.dataset.cpbPlan; if (radio) radio.checked = true; render(); };
      card.addEventListener('click', function (e) { if (e.target.closest('select')) return; set(); });
      radio && radio.addEventListener('change', set);
    });
    cadence && cadence.addEventListener('change', render);
    cadence && cadence.addEventListener('click', function (e) { e.stopPropagation(); });

    /* quantity */
    $$('[data-cpb-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var max = parseInt(qtyInput.max || '99', 10) || 99;
        qtyInput.value = Math.min(max, Math.max(1, qty() + parseInt(b.dataset.cpbQty, 10)));
        render();
      });
    });
    qtyInput && qtyInput.addEventListener('change', render);

    /* submit */
    function submit() {
      if (!variant.available) return;
      var item = { id: variant.id, quantity: qty() };
      if (plan === 'sub' && planId()) item.selling_plan = parseInt(planId(), 10);
      var btns = [atc, stickyBtn].filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
      cartAdd([item]).then(function () { toast('Added to cart'); })
        .catch(function (err) { toast(err.message || 'Could not add to cart'); })
        .then(function () { btns.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); }); });
    }
    /* The ATC is type="button" (not a submit) so third-party app scripts that hijack
       product-form submits (free-gift / upsell embeds) can't double-add or swallow the event. */
    atc && atc.addEventListener('click', function (e) { e.preventDefault(); submit(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); submit(); }, true);
    stickyBtn && stickyBtn.addEventListener('click', submit);

    /* sticky bar: show once the buy row has scrolled above the viewport */
    var buyRow = $('[data-cpb-buy-row]', form);
    if (stickyBar && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.bottom < 4;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', String(!show));
        });
      }, { threshold: 0 }).observe(buyRow);
    }

    /* gallery */
    var gallery = (function () {
      var slides = $$('[data-cpb-slide]', root), thumbs = $$('[data-cpb-thumb]', root), mobile = $('[data-cpb-mgallery]', root);
      var i = 0;
      function show(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          var v = s.querySelector('video'); if (v && k !== i && !v.paused) v.pause();
        });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i)); });
      }
      function showById(id) {
        var k = -1;
        slides.forEach(function (s, idx) { if (s.dataset.mediaId === String(id)) k = idx; });
        if (k > -1) show(k);
        if (mobile) {
          var ms = Array.prototype.filter.call(mobile.children, function (c) { return c.dataset.mediaId === String(id); })[0];
          if (ms) mobile.scrollTo({ left: ms.offsetLeft - mobile.offsetLeft, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.index, 10)); }); });
      var pv = $('[data-cpb-gprev]', root), nx = $('[data-cpb-gnext]', root);
      pv && pv.addEventListener('click', function () { show(i - 1); });
      nx && nx.addEventListener('click', function () { show(i + 1); });
      var stage = $('.cpb-gallery__stage', root);
      stage && stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1); });
      return { show: show, showById: showById };
    })();

    availability(); render();
  });

  /* ---------- UGC video cards: tap to play (with sound), mute toggle, one at a time ---------- */
  $$('[data-cpb-video]').forEach(function (card) {
    var v = $('video', card), play = $('[data-cpb-play]', card), mute = $('[data-cpb-mute]', card);
    if (!v) return;
    var soundOn = card.dataset.sound !== 'off';
    v.muted = !soundOn;
    function syncMute() {
      card.classList.toggle('is-muted', v.muted);
      if (mute) { mute.setAttribute('aria-pressed', String(v.muted)); mute.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute'); }
    }
    function pauseOthers() { $$('[data-cpb-video] video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); }); }
    function toggle() {
      if (v.paused) {
        pauseOthers();
        v.muted = !soundOn;
        v.play().catch(function (err) {
          /* Only fall back to a muted start when the browser refused audio playback; a pause() during
             load also rejects (AbortError) and must not restart the video. */
          if (err && err.name === 'NotAllowedError') { v.muted = true; v.play().catch(function () {}); syncMute(); }
        });
      } else { v.pause(); }
      syncMute();
    }
    play && play.addEventListener('click', toggle);
    v.addEventListener('click', toggle);
    mute && mute.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; syncMute(); });
    v.addEventListener('play', function () { card.classList.add('is-playing'); });
    v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    v.addEventListener('volumechange', syncMute);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { if (!en.isIntersecting && !v.paused) v.pause(); }); }).observe(card);
    syncMute();
  });

  /* ---------- cross-sell recommendations (Section Rendering API) ---------- */
  $$('[data-cpb-cross][data-url]').forEach(function (sec) {
    var row = $('[data-cpb-cross-row]', sec);
    if (!row) return;
    var load = function (url) {
      return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nr = doc.querySelector('[data-cpb-cross-row]');
        return nr && nr.children.length ? nr : null;
      });
    };
    load(sec.dataset.url).then(function (nr) { return nr || (sec.dataset.urlRelated ? load(sec.dataset.urlRelated) : null); })
      .then(function (nr) { if (nr) { row.innerHTML = nr.innerHTML; sec.hidden = false; } })
      .catch(function () { /* keep hidden */ });
  });
})();
